module.exports = __webpack_public_path__ + "static/media/shortinglistdown.319eac1a.svg";